const currentHostname = window.location.hostname;
const currentProtocol = window.location.protocol;
const functionsPort = import.meta.env.VITE_FUNCTIONS_PORT || "5001";

export default import.meta.env.DEV
  ? `${currentProtocol}//${currentHostname}:${functionsPort}/provokace-ai/europe-west1`
  : `${import.meta.env.VITE_FIREBASE_ENDPOINT_URL}`;
